module.exports = __webpack_public_path__ + "static/media/fullScreenIcon.35da0bb1.svg";